<div class="approw">
    <div class="row">
        <div class="col-lg-12">
            <ol class="breadcrumb">
                <li><a (click)="redirectToUrl('missioncontrol.dashboard', true)">{{MESSAGECONSTANTS.BREADCRUMBS.HOME}}</a></li>
                <li class="active"><span>Review Reports</span></li>
            </ol>
            <h1 class="heading-css">Review Reports</h1>
        </div>
    </div>
    <div class="col-lg-12 col-sm-12 col-md-12">
        <div class="main-box clearfix">
            <div class="main-box-body clearfix table-responsive">
                <div class="row review-reports-filter-container" *ngIf="companyType === 'Corporation'">
                    <div class="col-xs-12 candidate-type-filter">
                        <div class="radio candidate-type-option">
                            <input type="radio" name="candidateType" id="internalCandidates" [value]="false"
                                [(ngModel)]="filterObject.isVendorCandidates" (ngModelChange)="onCandidatesTypeChanged()">
                            <label for="internalCandidates">
                                <strong>Internal Candidates</strong>
                            </label>
                        </div>
                        <div class="radio candidate-type-option">
                            <input type="radio" name="candidateType" id="vendorCandidates" [value]="true"
                                [(ngModel)]="filterObject.isVendorCandidates" (ngModelChange)="onCandidatesTypeChanged()">
                            <label for="vendorCandidates">
                                <strong>Vendor Candidates</strong>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 review-reports-filter-container date-filter-container">
                        <div class="col-xs-4">
                            <div class="form-group">
                                <label for="startDate" class="control-label">
                                    Start Date:
                                </label>
                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <input #startDateInput type="text" name="startDate" id="startDate" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-4">
                            <div class="form-group">
                                <label for="endDate" class="control-label">
                                    End Date:
                                </label>
                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                    <input #endDateInput type="text" name="endDate" id="endDate" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isLoading">
                    <app-skeleton-loader variant="block"></app-skeleton-loader>
                </div>
                <table id="reportsTable" *ngIf="!isLoading" datatable [dtOptions]="dtOptions" class="table table-hover reports-table">
                    <thead>
                        <tr>
                            <th class="headerStyling text-center date-column">Appeared On</th>
                            <th class="headerStyling text-center date-column">Completed On</th>
                            <th class="headerStyling text-center">Candidate Name</th>
                            <th class="headerStyling text-center">Email</th>
                            <th class="headerStyling text-center">Requisition Number</th>
                            <th class="headerStyling text-center">Test Name</th>
                            <th class="headerStyling text-center">Status</th>
                            <th class="headerStyling text-center">Score</th>
                            <th class="headerStyling text-center">View Report</th>
                            <th class="headerStyling text-center">Image Proctoring</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let report of assessmentReports">
                            <td class="text-center" [attr.data-order]="report.appearedOn">
                                <span>
                                    {{report.appearedOn | fourDotFiveDateFormatPipe}}<br>
                                    {{report.appearedOn | fourDotFiveTimeFormatPipe}}
                                </span><br>
                                (<span class="font-bold utc-time">
                                    {{report.appearedOnDateUTC}}<br>
                                    {{report.appearedOnTimeUTC}} UTC
                                </span>)
                            </td>
                            <td class="text-center" [attr.data-order]="report.reportGeneratedDateTime">
                                <span>
                                    {{report.reportGeneratedDateTime | fourDotFiveDateFormatPipe}}<br>
                                    {{report.reportGeneratedDateTime | fourDotFiveTimeFormatPipe}}
                                </span><br>
                                (<span class="font-bold utc-time">
                                    {{report.reportGeneratedDateUTC}}<br>
                                    {{report.reportGeneratedTimeUTC}} UTC
                                </span>)
                            </td>
                            <td class="text-center">{{report.candidateName}}</td>
                            <td class="text-center">
                                <a href="mailto:{{report.email}}?Subject=" target="_top">{{report.email}}</a>
                            </td>
                            <td class="text-center">{{report.requisitionNumber}}</td>
                            <td class="text-center">{{report.testName}}</td>
                            <td class="text-center">{{report.status}}</td>
                            <td class="text-center">{{report.score}}</td>
                            <td class="text-center">
                                <i class="fas fa-exclamation-triangle fa-lg text-warning" *ngIf="report.violationType === 'Proctoring Issue'" tooltip="Proctoring Issue" container="body"></i>
                                <i class="fa fa-exclamation-circle fa-lg text-danger" *ngIf="report.violationType === 'Proctoring Violation'" tooltip="Proctoring Violation" container="body"></i>
                                <i class="fa fa-info-circle fa-lg text-primary" *ngIf="report.violationType === 'Information'" tooltip="Information" container="body"></i>
                                <a (click)="showReport(report)">
                                    <i class="fa fa-lg fas fa-file"></i>
                                </a>
                            </td>
                            <td class="text-center">
                                <i *ngIf="report.imageProctoring" class="fa fa-users" tooltip="Image Proctoring Enabled" container="body"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
